<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and legend -->
      <div>
        <b-card-title class="mb-50">
          New Wallets
        </b-card-title>
        <b-card-text class="mb-0 font-weight-bolder">
          Total: {{ Intl.NumberFormat('en-US').format((newTotal).toFixed(2)) }}
        </b-card-text>
      </div>
      <!--/ title and legend -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        type="line"
        height="270"
        :options="apexChartData.newWallets.chartOptions"
        :series="apexChartData.newWallets.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import apexChartData from './apexChartData'
import axios from 'axios'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardText,

    VueApexCharts,
  },
  data() {
    return {
      loaded: false,
      apexChartData,
      newTotal: 0,
    }
  },
  methods: {
  },
  mounted () {
    this.loaded = false
    const newUsersEndpoint = 'https://node-api.flipsidecrypto.com/api/v2/queries/de43113f-0f55-4284-961b-8aad4830a489/data/latest'
    axios.get(newUsersEndpoint)
    .then(response => {
      this.newTotal = response.data[response.data.length - 1].CUMULATIVE
      apexChartData.newWallets.series[0].data = []
      apexChartData.newWallets.series[1].data = []
      for (let datapoint in response.data){
        var x = new Date(response.data[datapoint].DATE)
        var y = response.data[datapoint]["New Wallets"]
        var y2 = response.data[datapoint].CUMULATIVE
        apexChartData.newWallets.series[0].data.push({
          x: x,
          y: y
        })
        apexChartData.newWallets.series[1].data.push({
          x: x,
          y: y2
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
